
import { SEOResults } from "@/components/SEOResults";
import Header from "@/components/Header";
import { formatMetrics, formatChecklist } from "@/components/results/MetricsFormatter";
import { RebrandingModal } from "@/components/RebrandingModal";
import { useState, useEffect } from "react";

const DemoResults = () => {
  const [showRebrandingModal, setShowRebrandingModal] = useState(false);

  useEffect(() => {
    // Check how many times the modal has been shown
    const modalViewCount = parseInt(localStorage.getItem('rebrandingModalViewCount') || '0');
    
    if (modalViewCount < 3) {
      setShowRebrandingModal(true);
      // Increment the count
      localStorage.setItem('rebrandingModalViewCount', (modalViewCount + 1).toString());
    }
  }, []);

  // Dados do JSON fornecido pelo backend
  const mockData = {
    "id": "6ba70d33-fac0-4603-9b70-6d2c347dfbff",
    "keyword": "marketing digital",
    "url": "https://rockcontent.com/br/blog/marketing-digital/",
    "created_at": "2025-06-02T11:50:28.297289",
    "error": false,
    "error_message": null,
    "analysis_result": {
        "error": false,
        "error_message": null,
        "total_time": 12.520735263824463,
        "api_version": "2.5",
        "keyword_summary": {
            "keyword": "marketing digital",
            "volume": 110000,
            "cpc": 0.63,
            "competition": 0.58,
            "number_of_results": 3010000000,
            "trend": [
                {
                    "year": 2025,
                    "month": 1,
                    "search_volume": 131513
                },
                {
                    "year": 2025,
                    "month": 2,
                    "search_volume": 131513
                },
                {
                    "year": 2025,
                    "month": 3,
                    "search_volume": 107159
                },
                {
                    "year": 2025,
                    "month": 4,
                    "search_volume": 107159
                },
                {
                    "year": 2025,
                    "month": 5,
                    "search_volume": 107159
                },
                {
                    "year": 2025,
                    "month": 6,
                    "search_volume": 107159
                },
                {
                    "year": 2025,
                    "month": 7,
                    "search_volume": 107159
                },
                {
                    "year": 2025,
                    "month": 8,
                    "search_volume": 87675
                },
                {
                    "year": 2025,
                    "month": 9,
                    "search_volume": 87675
                },
                {
                    "year": 2025,
                    "month": 10,
                    "search_volume": 131513
                },
                {
                    "year": 2025,
                    "month": 11,
                    "search_volume": 107159
                },
                {
                    "year": 2025,
                    "month": 12,
                    "search_volume": 107159
                }
            ]
        },
        "url_analyses": [
            {
                "error": false,
                "error_message": null,
                "url": "https://rockcontent.com/br/blog/marketing-digital/",
                "title": "Marketing Digital: o que é, como fazer, estratégias e TUDO sobre!",
                "title_length": 65,
                "meta_description": "Marketing Digital (mkt digital) é o conjunto de ações online com o objetivo de atrair negócios e fortalecer a marca. Aprenda tudo sobre Marketing Online!",
                "description_length": 153,
                "content_length": 17596,
                "backlinks": 550,
                "semrush": {
                    "backlinks": {
                        "ascore": 51,
                        "total": 2223,
                        "domains_num": 550,
                        "urls_num": 2235,
                        "ips_num": 641,
                        "ipclassc_num": 414,
                        "follows_num": 2013,
                        "nofollows_num": 224,
                        "sponsored_num": 6,
                        "ugc_num": 0,
                        "texts_num": 2265,
                        "images_num": 0,
                        "forms_num": 0,
                        "frames_num": 0
                    }
                },
                "boolean_criteria": {
                    "title_length_ok": false,
                    "keyword_in_title": true,
                    "keyword_in_meta": true,
                    "keyword_in_title_left": true,
                    "keyword_in_first_paragraph": true,
                    "has_single_h1": true,
                    "keyword_in_h1": true,
                    "keyword_in_h2": true,
                    "keyword_in_h3": true,
                    "clean_url": true,
                    "keyword_in_url": true,
                    "is_https": true
                },
                "position": 1,
                "google_position": 1,
                "scraping_metrics": {
                    "scrape_mode": "default",
                    "scrape_time": 0.6134424209594727,
                    "source": "api_default"
                },
                "url_time": 1.2137370109558105,
                "competitive_metrics": {
                    "position": 100,
                    "content_length": 100,
                    "backlinks": 100,
                    "referring_domains": 100,
                    "pagerank": 100
                },
                "comparative_score": 100.0,
                "checklist_score": 91.66,
                "seo_score": 95.83
            },
            {
                "error": false,
                "error_message": null,
                "url": "https://pt.wikipedia.org/wiki/Marketing_digital",
                "title": "Marketing digital – Wikipédia, a enciclopédia livre",
                "title_length": 49,
                "meta_description": "",
                "description_length": 0,
                "content_length": 8671,
                "backlinks": 542,
                "semrush": {
                    "backlinks": {
                        "ascore": 56,
                        "total": 2667,
                        "domains_num": 542,
                        "urls_num": 2538,
                        "ips_num": 749,
                        "ipclassc_num": 342,
                        "follows_num": 2403,
                        "nofollows_num": 265,
                        "sponsored_num": 2,
                        "ugc_num": 2,
                        "texts_num": 2668,
                        "images_num": 7,
                        "forms_num": 0,
                        "frames_num": 0
                    }
                },
                "boolean_criteria": {
                    "title_length_ok": true,
                    "keyword_in_title": true,
                    "keyword_in_meta": false,
                    "keyword_in_title_left": true,
                    "keyword_in_first_paragraph": true,
                    "has_single_h1": true,
                    "keyword_in_h1": true,
                    "keyword_in_h2": true,
                    "keyword_in_h3": true,
                    "clean_url": true,
                    "keyword_in_url": true,
                    "is_https": true
                },
                "position": 2,
                "google_position": 2,
                "scraping_metrics": {
                    "scrape_mode": "default",
                    "scrape_time": 0.04113411903381348,
                    "source": "api_default"
                },
                "url_time": 0.33158302307128906,
                "competitive_metrics": {
                    "position": 75,
                    "content_length": 25,
                    "backlinks": 75,
                    "referring_domains": 75,
                    "pagerank": 75
                },
                "comparative_score": 62.5,
                "checklist_score": 83.33,
                "seo_score": 72.91
            },
            {
                "error": false,
                "error_message": null,
                "url": "https://www.organicadigital.com/blog/afinal-como-funciona-o-marketing-digital/",
                "title": "Afinal, como funciona o Marketing Digital e como fazê-lo funcionar!",
                "title_length": 71,
                "meta_description": "Descubra como funciona o marketing digital, suas principais estratégias e técnicas para implementar com sucesso nas empresas.",
                "description_length": 134,
                "content_length": 5728,
                "backlinks": 204,
                "semrush": {
                    "backlinks": {
                        "ascore": 49,
                        "total": 336,
                        "domains_num": 204,
                        "urls_num": 329,
                        "ips_num": 238,
                        "ipclassc_num": 193,
                        "follows_num": 307,
                        "nofollows_num": 32,
                        "sponsored_num": 0,
                        "ugc_num": 0,
                        "texts_num": 338,
                        "images_num": 0,
                        "forms_num": 0,
                        "frames_num": 0
                    }
                },
                "boolean_criteria": {
                    "title_length_ok": false,
                    "keyword_in_title": true,
                    "keyword_in_meta": true,
                    "keyword_in_title_left": false,
                    "keyword_in_first_paragraph": true,
                    "has_single_h1": true,
                    "keyword_in_h1": true,
                    "keyword_in_h2": true,
                    "keyword_in_h3": true,
                    "clean_url": true,
                    "keyword_in_url": true,
                    "is_https": true
                },
                "position": 3,
                "google_position": 3,
                "scraping_metrics": {
                    "scrape_mode": "default",
                    "scrape_time": 1.5942118167877197,
                    "source": "api_default"
                },
                "url_time": 2.434036970138549,
                "competitive_metrics": {
                    "position": 50,
                    "content_length": 50,
                    "backlinks": 50,
                    "referring_domains": 50,
                    "pagerank": 50
                },
                "comparative_score": 50.0,
                "checklist_score": 83.33,
                "seo_score": 66.66
            },
            {
                "error": false,
                "error_message": null,
                "url": "https://sebrae.com.br/sites/PortalSebrae/artigos/marketing-digital-para-iniciantes-o-que-e-e-como-funciona,9f1ac3399eeab810VgnVCM1000001b00320aRCRD",
                "title": "Marketing digital para iniciantes: o que é e como funciona - Sebrae",
                "title_length": 72,
                "meta_description": "Sebrae",
                "description_length": 6,
                "content_length": 8874,
                "backlinks": 111,
                "semrush": {
                    "backlinks": {
                        "ascore": 55,
                        "total": 174,
                        "domains_num": 111,
                        "urls_num": 172,
                        "ips_num": 142,
                        "ipclassc_num": 107,
                        "follows_num": 155,
                        "nofollows_num": 19,
                        "sponsored_num": 0,
                        "ugc_num": 0,
                        "texts_num": 174,
                        "images_num": 0,
                        "forms_num": 0,
                        "frames_num": 0
                    }
                },
                "boolean_criteria": {
                    "title_length_ok": false,
                    "keyword_in_title": true,
                    "keyword_in_meta": false,
                    "keyword_in_title_left": true,
                    "keyword_in_first_paragraph": false,
                    "has_single_h1": true,
                    "keyword_in_h1": false,
                    "keyword_in_h2": true,
                    "keyword_in_h3": false,
                    "clean_url": true,
                    "keyword_in_url": true,
                    "is_https": true
                },
                "position": 4,
                "google_position": 4,
                "scraping_metrics": {
                    "scrape_mode": "default",
                    "scrape_time": 0.42078113555908203,
                    "source": "api_default"
                },
                "url_time": 0.6147239208221436,
                "competitive_metrics": {
                    "position": 25,
                    "content_length": 75,
                    "backlinks": 25,
                    "referring_domains": 25,
                    "pagerank": 25
                },
                "comparative_score": 37.5,
                "checklist_score": 66.66,
                "seo_score": 52.08
            }
        ],
        "ai_insights": [
            {
                "id": 1,
                "title": "Aprimorar título para respeitar limite de caracteres",
                "description": "O título atual não respeita o limite de 60 caracteres, o que pode impactar na exibição nos resultados de busca e na experiência do usuário.",
                "action": "Reformule o título para que tenha até 60 caracteres, mantendo a palavra-chave.",
                "expected_result": "Melhoria na exibição do título nos resultados de busca, potencialmente aumentando a taxa de cliques."
            },
            {
                "id": 2,
                "title": "Expandir conteúdo para aumentar a autoridade temática",
                "description": "Embora o conteúdo já seja extenso, há uma oportunidade para ser ainda mais abrangente em tópicos relacionados ao marketing digital.",
                "action": "Adicione seções que abordem tendências atuais e estudos de caso relevantes em marketing digital.",
                "expected_result": "Fortalecimento da autoridade da página e aumento do tempo de permanência dos usuários."
            },
            {
                "id": 3,
                "title": "Aumentar backlinks para melhorar a autoridade",
                "description": "Com 550 backlinks, a URL analisada supera os concorrentes, mas o aumento dessa quantidade pode consolidar ainda mais a posição.",
                "action": "Implemente uma estratégia de Digital PR focada em conseguir links de sites relevantes e de alta autoridade.",
                "expected_result": "Maior fortalecimento da autoridade da página e resistência a mudanças no ranking."
            },
            {
                "id": 4,
                "title": "Melhorar a presença de palavras-chave em H2 e H3",
                "description": "Apesar de a palavra-chave estar presente em H2 e H3, uma maior variedade de palavras-chave relacionadas pode ser benéfica.",
                "action": "Inclua palavras-chave secundárias e sinônimos nos H2 e H3 para expandir a relevância semântica.",
                "expected_result": "Melhora na relevância semântica da página e potencial aumento no tráfego orgânico."
            },
            {
                "id": 5,
                "title": "Refinar a arquitetura do conteúdo para melhor navegação",
                "description": "Um conteúdo muito longo pode dificultar a navegação e a retenção do usuário.",
                "action": "Adicione um índice ou sumário no início do conteúdo para facilitar a navegação.",
                "expected_result": "Melhor experiência do usuário e potencial aumento no tempo de permanência na página."
            },
            {
                "id": 6,
                "title": "Monitorar e ajustar o desempenho de SEO regularmente",
                "description": "Com a posição atual em 1, é crucial acompanhar constantemente métricas de SEO para evitar quedas.",
                "action": "Estabeleça uma rotina mensal de análise de métricas de SEO e ajuste a estratégia conforme necessário.",
                "expected_result": "Manutenção da posição de destaque e adaptação rápida a mudanças no comportamento de busca."
            }
        ]
    }
  };

  const mainAnalysis = mockData.analysis_result.url_analyses[0];
  const metrics = formatMetrics({ mainAnalysis });
  const checklist = formatChecklist({ mainAnalysis });

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <RebrandingModal 
        isOpen={showRebrandingModal} 
        onClose={() => setShowRebrandingModal(false)} 
      />
      <SEOResults
        score={mainAnalysis.seo_score}
        metrics={metrics}
        checklist={checklist}
        keywordData={mockData.analysis_result.keyword_summary}
        urlAnalyses={mockData.analysis_result.url_analyses}
        aiInsights={mockData.analysis_result.ai_insights}
      />
    </div>
  );
};

export default DemoResults;
